import bigDecimal from 'js-big-decimal';

import type { OutboxWrapper } from '../../../../models/outbox';

const calculateCurrenciesTotals = (data: OutboxWrapper[]) => {
    return data.reduce<Record<string, number>>((acc, outboxWrapper) => {
        const { amount, currency } = outboxWrapper;
        const currencyStr = currency as string;

        if (currencyStr in acc) {
            acc[currencyStr] = Number.parseFloat(bigDecimal.add(acc[currencyStr], amount));
        } else {
            acc[currencyStr] = amount;
        }

        return acc;
    }, {});
};

export default calculateCurrenciesTotals;
